import { Box, Breadcrumbs, Container, Link, Typography } from '@mui/material'
import { NavLink, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import PageHeader from '../components/PageHeader'
import AIAgentChatWidget from '../components/AIAgentChatWidget'
import AIAgentPinGate from '../components/AIAgentPinGate'

export default function AIAgentChatPage() {
  const [t] = useTranslation('common')
  const navigate = useNavigate()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <Container
      maxWidth={false}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minHeight: 0,
        maxHeight: '100%',
        overflow: 'hidden',
        p: { xs: 0, md: 2 }
      }}
    >
      {!isMobile && (
        <PageHeader
          title={t('Sidebar.aiAgent', { defaultValue: 'AI-agentti' })}
          compact
          breadcrumbs={
            <Breadcrumbs>
              <Link component={NavLink} to="/">
                {t('Sidebar.frontpage', { defaultValue: 'Etusivu' })}
              </Link>
              <Typography>{t('Sidebar.aiAgent', { defaultValue: 'AI-agentti' })}</Typography>
            </Breadcrumbs>
          }
        />
      )}

      <Box sx={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
        <AIAgentPinGate onCancel={() => navigate('/', { replace: true })}>
          <AIAgentChatWidget />
        </AIAgentPinGate>
      </Box>
    </Container>
  )
}
